/**
 * Release tour — Inventory & Stock Management.
 *
 * Introduces the `/stock` workspace (8-tab shell ported from the Flutter
 * `StockScreen`, since extended with Stores + Reconciliation — see
 * `frame-stock.tsx`'s `STOCK_TABS`). Anchors are real `data-tour` attributes on
 * `frame-stock.tsx` (shared shell, so the tab step fires from any /stock/* tab)
 * and `stock-items-page.tsx` (Tab 1 — Stock Item Enquiry, the module's landing tab).
 *
 * Mount at the top of `StockItemsPage`:
 *   const tour = useReleaseTour(INVENTORY_STOCK_TOUR, { userRole: user.role });
 *   return <FrameStock ...>{...}<ReleaseTour {...tour} /></FrameStock>;
 */
import type { ReleaseTourConfig } from '../release-tour-types';
import { registerReleaseTour } from '../release-tour-registry';

export const INVENTORY_STOCK_TOUR: ReleaseTourConfig = {
  id: 'inventory-stock-management-v3',
  name: 'Inventory & Stock Management',
  enabled: true,
  steps: [
    {
      target: '[data-tour="stock-tabs"]',
      title: 'Introducing Stock Management',
      content:
        'Built from scratch on Scrips’ new engine — item enquiry, transfer, consumption, supplier, stores, receive, request, and reconciliation, all in one connected workspace.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="stock-search"]',
      title: 'Find any item instantly',
      content: 'Search by code or description to see live on-hand quantity across every location.',
      placement: 'right',
    },
    {
      target: '[data-tour="stock-add-item"]',
      title: 'Add items and automate reordering',
      content:
        'Add a new stock item, or run the reorder sweep to auto-draft requests for anything at or below its reorder level.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="stock-table"]',
      title: 'Drill into any item',
      content:
        'Open the row menu on any item to view its full stock movement history or set a custom reorder level.',
      placement: 'top',
    },
    {
      target: '[data-tour="stock-table"]',
      title: 'This is just the beginning',
      content:
        'Faster, more accurate, and built to grow — this workspace is the foundation for what’s next: AI that spots a shortfall before it happens. This tour won’t show again.',
      placement: 'top',
    },
  ],
};

registerReleaseTour(INVENTORY_STOCK_TOUR);
